export const settings_aws_marketplace_en = {
  settings_aws_marketplace_confirm:
    "Connect this AWS Marketplace subscription to this workspace? AWS will bill your AWS account for the credits this workspace uses.",
  settings_aws_marketplace_connect: "Connect",
  settings_aws_marketplace_title: "AWS Marketplace",
  settings_aws_marketplace_desc:
    "Your AWS Marketplace subscription pays for the credits this workspace uses. AWS bills your AWS account every hour for the credits used, so your Pubrio balance is never drawn down.",
  settings_aws_marketplace_link_success:
    "Your AWS Marketplace subscription is now connected to this workspace.",
  settings_aws_marketplace_link_failed:
    "This AWS Marketplace subscription could not be connected. It may already belong to another workspace, or the link has expired. Open Pubrio again from your AWS Marketplace subscription.",
  settings_aws_marketplace_subscriptions: "Subscriptions",
  settings_aws_marketplace_empty: "No AWS Marketplace subscription is connected to this workspace.",
  settings_aws_marketplace_account: "AWS account",
  settings_aws_marketplace_status_pending: "Waiting for AWS to confirm",
  settings_aws_marketplace_status_active: "Active",
  settings_aws_marketplace_status_deprovisioning: "Ending",
  settings_aws_marketplace_status_ended: "Ended",
};

export const settings_aws_marketplace_zhCN = {
  settings_aws_marketplace_confirm:
    "将此 AWS Marketplace 订阅关联到此工作区？AWS 将按此工作区使用的积分向您的 AWS 账户计费。",
  settings_aws_marketplace_connect: "关联",
  settings_aws_marketplace_title: "AWS Marketplace",
  settings_aws_marketplace_desc:
    "您的 AWS Marketplace 订阅将支付此工作区使用的积分。AWS 每小时按已用积分向您的 AWS 账户计费，因此不会扣减您的 Pubrio 余额。",
  settings_aws_marketplace_link_success: "您的 AWS Marketplace 订阅已关联到此工作区。",
  settings_aws_marketplace_link_failed:
    "无法关联此 AWS Marketplace 订阅。它可能已属于其他工作区，或链接已失效。请从您的 AWS Marketplace 订阅重新打开 Pubrio。",
  settings_aws_marketplace_subscriptions: "订阅",
  settings_aws_marketplace_empty: "此工作区尚未关联任何 AWS Marketplace 订阅。",
  settings_aws_marketplace_account: "AWS 账户",
  settings_aws_marketplace_status_pending: "等待 AWS 确认",
  settings_aws_marketplace_status_active: "有效",
  settings_aws_marketplace_status_deprovisioning: "即将结束",
  settings_aws_marketplace_status_ended: "已结束",
};

export const settings_aws_marketplace_zhTW = {
  settings_aws_marketplace_confirm:
    "將此 AWS Marketplace 訂閱連結到此工作區？AWS 將按此工作區使用的積分向您的 AWS 帳戶收費。",
  settings_aws_marketplace_connect: "連結",
  settings_aws_marketplace_title: "AWS Marketplace",
  settings_aws_marketplace_desc:
    "您的 AWS Marketplace 訂閱將支付此工作區使用的積分。AWS 每小時按已用積分向您的 AWS 帳戶收費，因此不會扣減您的 Pubrio 餘額。",
  settings_aws_marketplace_link_success: "您的 AWS Marketplace 訂閱已連結到此工作區。",
  settings_aws_marketplace_link_failed:
    "無法連結此 AWS Marketplace 訂閱。它可能已屬於其他工作區，或連結已失效。請從您的 AWS Marketplace 訂閱重新開啟 Pubrio。",
  settings_aws_marketplace_subscriptions: "訂閱",
  settings_aws_marketplace_empty: "此工作區尚未連結任何 AWS Marketplace 訂閱。",
  settings_aws_marketplace_account: "AWS 帳戶",
  settings_aws_marketplace_status_pending: "等待 AWS 確認",
  settings_aws_marketplace_status_active: "有效",
  settings_aws_marketplace_status_deprovisioning: "即將結束",
  settings_aws_marketplace_status_ended: "已結束",
};

export const settings_aws_marketplace_ja = {
  settings_aws_marketplace_confirm:
    "この AWS Marketplace のサブスクリプションをこのワークスペースに接続しますか？このワークスペースで使用したクレジットは AWS アカウントに請求されます。",
  settings_aws_marketplace_connect: "接続",
  settings_aws_marketplace_title: "AWS Marketplace",
  settings_aws_marketplace_desc:
    "このワークスペースで使用するクレジットは AWS Marketplace のサブスクリプションで支払われます。AWS は使用したクレジットを 1 時間ごとに AWS アカウントへ請求するため、Pubrio の残高は減りません。",
  settings_aws_marketplace_link_success: "AWS Marketplace のサブスクリプションがこのワークスペースに接続されました。",
  settings_aws_marketplace_link_failed:
    "この AWS Marketplace のサブスクリプションを接続できませんでした。すでに別のワークスペースに接続されているか、リンクの有効期限が切れています。AWS Marketplace のサブスクリプションから Pubrio をもう一度開いてください。",
  settings_aws_marketplace_subscriptions: "サブスクリプション",
  settings_aws_marketplace_empty: "このワークスペースに接続された AWS Marketplace のサブスクリプションはありません。",
  settings_aws_marketplace_account: "AWS アカウント",
  settings_aws_marketplace_status_pending: "AWS の確認待ち",
  settings_aws_marketplace_status_active: "有効",
  settings_aws_marketplace_status_deprovisioning: "終了処理中",
  settings_aws_marketplace_status_ended: "終了",
};

export const settings_aws_marketplace_ko = {
  settings_aws_marketplace_confirm:
    "이 AWS Marketplace 구독을 이 워크스페이스에 연결할까요? 이 워크스페이스에서 사용한 크레딧은 AWS 계정으로 청구됩니다.",
  settings_aws_marketplace_connect: "연결",
  settings_aws_marketplace_title: "AWS Marketplace",
  settings_aws_marketplace_desc:
    "이 워크스페이스에서 사용하는 크레딧은 AWS Marketplace 구독으로 결제됩니다. AWS가 사용한 크레딧을 매시간 AWS 계정으로 청구하므로 Pubrio 잔액은 차감되지 않습니다.",
  settings_aws_marketplace_link_success: "AWS Marketplace 구독이 이 워크스페이스에 연결되었습니다.",
  settings_aws_marketplace_link_failed:
    "이 AWS Marketplace 구독을 연결할 수 없습니다. 이미 다른 워크스페이스에 연결되었거나 링크가 만료되었을 수 있습니다. AWS Marketplace 구독에서 Pubrio를 다시 열어 주세요.",
  settings_aws_marketplace_subscriptions: "구독",
  settings_aws_marketplace_empty: "이 워크스페이스에 연결된 AWS Marketplace 구독이 없습니다.",
  settings_aws_marketplace_account: "AWS 계정",
  settings_aws_marketplace_status_pending: "AWS 확인 대기 중",
  settings_aws_marketplace_status_active: "활성",
  settings_aws_marketplace_status_deprovisioning: "종료 중",
  settings_aws_marketplace_status_ended: "종료됨",
};

export const settings_aws_marketplace_hi = {
  settings_aws_marketplace_confirm:
    "इस AWS Marketplace सदस्यता को इस वर्कस्पेस से जोड़ें? इस वर्कस्पेस में इस्तेमाल हुए क्रेडिट का बिल आपके AWS खाते में जाएगा।",
  settings_aws_marketplace_connect: "जोड़ें",
  settings_aws_marketplace_title: "AWS Marketplace",
  settings_aws_marketplace_desc:
    "इस वर्कस्पेस में इस्तेमाल होने वाले क्रेडिट का भुगतान आपकी AWS Marketplace सदस्यता से होता है। AWS हर घंटे इस्तेमाल हुए क्रेडिट का बिल आपके AWS खाते में भेजता है, इसलिए आपका Pubrio बैलेंस कम नहीं होता।",
  settings_aws_marketplace_link_success: "आपकी AWS Marketplace सदस्यता अब इस वर्कस्पेस से जुड़ गई है।",
  settings_aws_marketplace_link_failed:
    "यह AWS Marketplace सदस्यता जोड़ी नहीं जा सकी। हो सकता है यह पहले से किसी दूसरे वर्कस्पेस से जुड़ी हो, या लिंक की अवधि समाप्त हो गई हो। अपनी AWS Marketplace सदस्यता से Pubrio को फिर से खोलें।",
  settings_aws_marketplace_subscriptions: "सदस्यताएँ",
  settings_aws_marketplace_empty: "इस वर्कस्पेस से कोई AWS Marketplace सदस्यता नहीं जुड़ी है।",
  settings_aws_marketplace_account: "AWS खाता",
  settings_aws_marketplace_status_pending: "AWS की पुष्टि का इंतज़ार",
  settings_aws_marketplace_status_active: "सक्रिय",
  settings_aws_marketplace_status_deprovisioning: "समाप्त हो रही है",
  settings_aws_marketplace_status_ended: "समाप्त",
};
